import { render, staticRenderFns } from "./MapSvg84.vue?vue&type=template&id=05ea2876"
import script from "./MapSvg84.vue?vue&type=script&setup=true&lang=ts"
export * from "./MapSvg84.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports